import { Translations } from '@typings';

import { LANGUAGE_NAME_MAP } from '../../../constants/translation';

export const getIsLanguageSupported = (language: string): language is Translations.SupportedLanguagesCodes => {
  return language in LANGUAGE_NAME_MAP;
};
